import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=65b6a127&scoped=true&"
import script from "./Logo.vue?vue&type=script&lang=js&"
export * from "./Logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b6a127",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65b6a127')) {
      api.createRecord('65b6a127', component.options)
    } else {
      api.reload('65b6a127', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=65b6a127&scoped=true&", function () {
      api.rerender('65b6a127', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/forms/v2/schema/Logo.vue"
export default component.exports